"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var StringLiteralObfuscatingReplacer_1;
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../../../container/ServiceIdentifiers");
const StringArrayEncoding_1 = require("../../../../enums/StringArrayEncoding");
const AbstractObfuscatingReplacer_1 = require("../AbstractObfuscatingReplacer");
const NodeMetadata_1 = require("../../../../node/NodeMetadata");
const NodeFactory_1 = require("../../../../node/NodeFactory");
const NumberUtils_1 = require("../../../../utils/NumberUtils");
let StringLiteralObfuscatingReplacer = StringLiteralObfuscatingReplacer_1 = class StringLiteralObfuscatingReplacer extends AbstractObfuscatingReplacer_1.AbstractObfuscatingReplacer {
    constructor(stringArrayStorage, stringArrayStorageAnalyzer, options) {
        super(options);
        this.nodesCache = new Map();
        this.stringArrayStorage = stringArrayStorage;
        this.stringArrayStorageAnalyzer = stringArrayStorageAnalyzer;
    }
    static getHexadecimalLiteralNode(hexadecimalIndex) {
        const hexadecimalLiteralNode = NodeFactory_1.NodeFactory.literalNode(hexadecimalIndex);
        NodeMetadata_1.NodeMetadata.set(hexadecimalLiteralNode, { replacedLiteral: true });
        return hexadecimalLiteralNode;
    }
    static getRc4KeyLiteralNode(literalValue) {
        const rc4KeyLiteralNode = NodeFactory_1.NodeFactory.literalNode(literalValue);
        NodeMetadata_1.NodeMetadata.set(rc4KeyLiteralNode, { replacedLiteral: true });
        return rc4KeyLiteralNode;
    }
    initialize() {
        if (this.options.shuffleStringArray) {
            this.stringArrayStorage.shuffleStorage();
        }
        if (this.options.rotateStringArray) {
            this.stringArrayStorage.rotateStorage();
        }
    }
    replace(literalNode) {
        const literalValue = literalNode.value;
        if (typeof literalValue !== 'string') {
            throw new Error('`StringLiteralObfuscatingReplacer` should accept only literals with `string` value');
        }
        const stringArrayStorageItemData = this.stringArrayStorageAnalyzer
            .getItemDataForLiteralNode(literalNode);
        const cacheKey = `${literalValue}-${Boolean(stringArrayStorageItemData)}`;
        const useCachedValue = this.nodesCache.has(cacheKey) && this.options.stringArrayEncoding !== StringArrayEncoding_1.StringArrayEncoding.Rc4;
        if (useCachedValue) {
            return this.nodesCache.get(cacheKey);
        }
        const resultNode = stringArrayStorageItemData
            ? this.replaceWithStringArrayCallNode(stringArrayStorageItemData)
            : this.replaceWithLiteralNode(literalValue);
        this.nodesCache.set(cacheKey, resultNode);
        return resultNode;
    }
    replaceWithLiteralNode(value) {
        return NodeFactory_1.NodeFactory.literalNode(value);
    }
    replaceWithStringArrayCallNode(stringArrayStorageItemData) {
        const { index, decodeKey } = stringArrayStorageItemData;
        const hexadecimalIndex = NumberUtils_1.NumberUtils.toHex(index);
        const callExpressionArgs = [
            StringLiteralObfuscatingReplacer_1.getHexadecimalLiteralNode(hexadecimalIndex)
        ];
        if (decodeKey) {
            callExpressionArgs.push(StringLiteralObfuscatingReplacer_1.getRc4KeyLiteralNode(decodeKey));
        }
        const stringArrayIdentifierNode = NodeFactory_1.NodeFactory.identifierNode(this.stringArrayStorage.getStorageCallsWrapperName());
        return NodeFactory_1.NodeFactory.callExpressionNode(stringArrayIdentifierNode, callExpressionArgs);
    }
};
__decorate([
    inversify_1.postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], StringLiteralObfuscatingReplacer.prototype, "initialize", null);
StringLiteralObfuscatingReplacer = StringLiteralObfuscatingReplacer_1 = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IStringArrayStorage)),
    __param(1, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IStringArrayStorageAnalyzer)),
    __param(2, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [Object, Object, Object])
], StringLiteralObfuscatingReplacer);
exports.StringLiteralObfuscatingReplacer = StringLiteralObfuscatingReplacer;
